import { RouteEntry } from "../../shared/routes";
import { CalendarHome } from "./CalendarHome";
import { SearchCalendar } from "./SearchCalendar";

export const calendarRoutes: Array<RouteEntry> = [
    { path: '/calendar/search/:searchText?', component: SearchCalendar, authorize: true, },
    { path: '/calendar/:ignoredEventName?/:calendarEventScheduleId?', exact: true, component: CalendarHome, authorize: true, },
];
